<!--
 * @Author: your name
 * @Date: 2021-08-09 15:14:26
 * @LastEditTime: 2022-03-07 09:53:12
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\views\layout\components\top.vue
-->
<template>
    <div class="top_back_div">
        <div class="personal_content">
            <div class="personal_div">
                <img src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/logo/logo.png" alt="" @click="toIndex">
                <search-com />
            </div>
        </div>
    </div>
</template>
<script>
import searchCom from '../pageComponents/searchCom.vue'
export default {
    components: {searchCom},
    data() {
        return {};
    },
    methods: {
        toIndex() {
            this.$router.push({ path: "/" });
        },
    },
};
</script>
<style scoped>
.top_back_div {
    background-color: #f8f8f8;
}
/* 个人中心-头部 */
.personal_content {
    width: 100%;
    height: 112px;
    background-color: #ffffff;
}
.personal_div {
    width: 1200px;
    height: 112px;
    margin: 0 auto;
    display: flex;
    align-items: center;
}
.personal_div > img {
    width: 196px;
    margin-left: 25px;
    margin-right: 246px;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/cart/cartHeader.vue